import React from "react";
import { useObjectStore } from "../zustand/objects";
import { ActionIcon, Tooltip, TextInput } from "@mantine/core";
import { IconTag } from "@tabler/icons-react";

const ObjectTitleName = ({ open, title, id, isLocked, borderColour }) => {
  const { arrangeUndoRedo, updateObjectTitle, currentObjectArtboard, updateObjectTitleStatus, editingObjectTitle } =
    useObjectStore();

  const handleClick = () => {
    updateObjectTitleStatus(true);
  };

  const handleSubmit = (val) => {
    arrangeUndoRedo({
      updateType: "objectUpdate",
      artboard: currentObjectArtboard,
      objectID: id,
      undo: false,
      field: "objectTitle",
    });
    updateObjectTitle(id, currentObjectArtboard, val, false);
    updateObjectTitleStatus(false);
  };

  return (
    <>
      {editingObjectTitle ? (
        <TextInput
          id="outlined-basic"
          defaultValue={title}
          autoFocus
          style={{ width: "100px" }}
          onBlur={(e) => handleSubmit(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit(e.currentTarget.value);
            }
          }}
        />
      ) : (
        <Tooltip label="Edit object name">
          <ActionIcon
            onClick={() => !isLocked && handleClick()}
            size={"md"}
            variant="outline"
            aria-label="Edit object title"
            color={borderColour}
          >
            <IconTag style={{ width: "70%", height: "70%" }} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      )}
    </>
  );
};

export default ObjectTitleName;
